// Central registry of all admin cards.
// Add new module admin cards here to automatically include them in the Admin Hub.

import { layoutAdminCard } from '../modules/layouts';
import { bannerAdminCard } from '../modules/banners';
import { faqAdminCard } from '../modules/faq';
import type { AdminCard } from './types';

export const adminCards: AdminCard[] = [layoutAdminCard, bannerAdminCard, faqAdminCard];
